"use strict";

var config = {
    timeout: 10000,
    disables: [],
    enables: ["x5"],
    urlParamNames: [], // custom
    cacheType: "cookie",
    cookieNames: ["locallat", "locallng"],
    storageName: "whereami",
    wxAutoConfig: false,
    city: false,
    source: "",
    sampling: 0.5, // 自定义采样率，与source配合使用
    debug: false
};

exports.get = function (key) {
    return config[key];
};

exports.set = function (key, value) {
    config[key] = value;
};

exports.config = function (obj) {
    Object.keys(obj).forEach(function (key) {
        config[key] = obj[key];
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/config.js
// module id = 5
// module chunks = 0